import {
  CheckCircleOutlined,
  EllipsisOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import ItemPrint from "../../../components/print/print_item";
import SelectLayoutNew from "../../../components/select-layout/SelectLayoutNew";
import SelectMaterialHandling from "../../../components/SelectMaterialHandling";
import SelectOperator from "../../../components/SelectOperator";
import SelectPalletByClient from "../../../components/SelectPalletByClient";
import SelectProductByClient from "../../../components/SelectProductByClient";
import API from "../../../services/api-request";
import { capitalizeLetter } from "../../../utils/capitalizeLetter";
import Process from "./process";

function hasDestinationConflict(A, product_data) {
  for (const item of A) {
    const match = product_data.find(
      (p) => p.pallet_id === item.pallet_destination_id,
    );

    if (match && match.product_id !== item.product_id) {
      return true;
    }
  }
  return false;
}

const StartOutbound = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editForm] = Form.useForm();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [selectionIndex, setSelectionIndex] = useState(0);
  const [selectedArea, setSelectedArea] = useState({});

  const [open, setOpen] = useState(false);

  const [openProcess, setOpenProcess] = useState(false);

  const [dataPallet, setDataPallet] = useState([]);
  const [loadingPallet, setLoadingPallet] = useState(false);
  const [triggerRender, setTriggerRender] = useState(false);

  const [clientId, setClientId] = useState(null);

  const [isCustomMaterialHandling, setIsCustomMaterialHandling] =
    useState(false);
  const [materialHandlingChecked, setMaterialHandlingChecked] = useState(false);

  const [selectedPallet, setSelectedPallet] = useState(null);
  const [productData, setProductData] = useState([]);

  const [confirmOutbound, setConfirmOutbound] = useState(false);

  const onSelectedMaterialHandling = (value, options) => {
    editForm.setFieldValue("material_handling_fee_type", value);
    editForm.setFieldValue("material_handling_fee_cost", options?.cost);
    setIsCustomMaterialHandling(value === "custom");
  };

  const onSelectedDestinationPallet = (value, index) => {
    if (!value) {
      const originalAreaId = editForm.getFieldValue([
        "details",
        index,
        "original_area_id",
      ]);

      const originalArea = editForm.getFieldValue([
        "details",
        index,
        "original_area",
      ]);

      editForm.setFieldValue(["details", index, "area_id"], originalAreaId);
      editForm.setFieldValue(["details", index, "area"], originalArea);
      return;
    }

    const pallet = productData.find((e) => e.pallet_id === value);

    if (pallet) {
      editForm.setFieldValue(["details", index, "area_id"], pallet.area_id);
      editForm.setFieldValue(["details", index, "area"], pallet.area_name);
    }
  };

  const getPallet = async () => {
    setLoadingPallet(true);
    try {
      const res = await API.Get(`pallet`);
      setDataPallet(res?.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingPallet(false);
    }
  };

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const showModalProcess = () => {
    setOpenProcess(true);
  };

  const handleCancelProcess = () => {
    setOpenProcess(false);
  };

  const handleOkProcess = (data, weighingCount) => {
    onSelectedPallet(data.pallet.id, data.pallet);

    if (data.pallet.id) {
      onSelectedPallet(data.pallet.id, data.pallet);
      editForm.setFieldValue(
        ["details", selectionIndex, "pallet_destination_id"],
        data.pallet.id,
      );
    }

    if (data.operator.id) {
      editForm.setFieldValue(
        ["details", selectionIndex, "operator_id"],
        data.operator.id,
      );
    }

    if (data.weight.weight >= 0) {
      if (weighingCount === 1) {
        editForm.setFieldValue(
          ["details", selectionIndex, "weight"],
          data.weight.weight,
        );
      }
      if (weighingCount >= 2) {
        editForm.setFieldValue(
          ["details", selectionIndex, "remaining_weight"],
          data.weight.weight,
        );
      }
    }
  };

  const onSelectProduct = (value, option, index) => {
    editForm.setFieldValue("id", value);
    editForm.setFieldValue(["details", index, "qty"], option?.quantity);
    editForm.setFieldValue(["details", index, "id"], value);
    editForm.setFieldValue(["details", index, "pallet_id"], option?.pallet_id);
    editForm.setFieldValue(["details", index, "area_id"], option?.area_id);
    editForm.setFieldValue(["details", index, "area"], option?.area);
    editForm.setFieldValue(
      ["details", index, "original_area_id"],
      option?.area_id,
    );
    editForm.setFieldValue(["details", index, "original_area"], option?.area);
    editForm.setFieldValue(["details", index, "level"], option?.level);
    editForm.setFieldValue(
      ["details", index, "warehouse"],
      option?.warehouse_name,
    );
    editForm.setFieldValue(
      ["details", index, "product_id"],
      option?.product_id,
    );
    editForm.setFieldValue(["details", index, "name"], option?.name);
    editForm.setFieldValue(
      ["details", index, "specification"],
      option?.specification,
    );
    editForm.setFieldValue(
      ["details", index, "schedule_at"],
      option?.schedule_at,
    );

    const pallet = dataPallet.find(
      (pallet) => +pallet.pallet_id === +option?.pallet_id,
    );

    editForm.setFieldValue(["details", index, "pallet_type"], pallet?.type);

    if (pallet?.type === "besi") {
      editForm.setFieldValue(["details", index, "pallet_weight"], 85);
    } else {
      editForm.setFieldValue(["details", index, "pallet_weight"], "");
    }
  };

  const getDataDetail = async (id) => {
    setLoading(true);

    try {
      // Ambil detail transaksi
      const result = await API.Get(`transaction/outbound/detail/${id}`);

      setClientId(result?.data?.client_id);

      // Ambil daftar produk berdasarkan client_id
      const productLocations = await API.Get(
        `transaction/outbound/list-product?client_id=${result?.data?.client_id}`,
      );

      // Pastikan transaction_details tidak undefined/null
      const productIds =
        result?.data?.transaction_details?.map((item) => item.product_id) || [];

      // Filter produk berdasarkan product_id & schedule_at == inbound_date
      const filtered = (productLocations?.data || []).filter((item) => {
        const inboundDate = result?.data?.transaction_details?.find(
          (detail) => detail.product_id === item.product_id,
        )?.inbound_date;

        // Pastikan inboundDate dan schedule_at memiliki format yang sesuai
        return (
          productIds.includes(item.product_id) &&
          dayjs(inboundDate).format("YYYY-MM-DD") ===
          dayjs(item.schedule_at).format("YYYY-MM-DD")
        );
      });

      // Bentuk objek yang telah dimodifikasi
      const transformedItem = {
        ...result?.data,
        status: capitalizeLetter(result?.data?.status),
        client: result?.data?.client?.name,
        request_at: dayjs(result?.data?.request_at).format("YYYY-MM-DD"),
        schedule_at: dayjs(result?.data?.schedule_at).format("YYYY-MM-DD"),
        details: result?.data?.transaction_details?.map((e, index) => {
          return {
            transaction_detail_id: e.id,
            product_id: e.product_id,
            qty: e.estimate_qty,
            // weight: e.estimate_weight,
            specification: e.estimate_specification,
            area: filtered[index]?.area_name,
            area_id: filtered[index]?.area_id,
            pallet_id: filtered[index]?.pallet_id,
            select_product: filtered[index]?.id,
          };
        }),
        products: filtered, // Menyimpan data yang sudah difilter berdasarkan product_id & inbound_date
      };

      transformedItem?.details?.forEach((item, index) => {
        const palletData = dataPallet.find((p) => p.id === item.pallet_id);

        onSelectedPallet(item.pallet_id, palletData, index);
      });

      // Setel nilai form dengan data yang sudah diubah
      editForm.setFieldsValue(transformedItem);

      // Simpan data dalam state
      setData(transformedItem);
    } catch (error) {
      console.error(error);
      message.info("Failed Fetch Outbound Detail");
    } finally {
      // Pastikan loading dihentikan meskipun terjadi error
      setLoading(false);
    }
  };

  useEffect(() => {
    getPallet();
    if (id) {
      getDataDetail(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onFinish = async (values) => {
    setLoadingBtn(true);
    try {
      const {
        code,
        details,
        material_handling_fee_type,
        material_handling_fee_cost,
        note,
        request_at,
        schedule_at,
      } = values;

      let dataForm = {
        client_id: data?.client_id,
        code,
        schedule_at,
        request_at,
        note,
        material_handling_fee_cost: material_handling_fee_cost || 0,
        details: details.map((e, index) => {
          return {
            transaction_detail_id: e.transaction_detail_id,
            product_id: e.product_id,
            operator_id: e.operator_id,
            qty: e.qty ?? 0,
            weight: e.weight,
            name: data?.products?.[index]?.name,
            specification: e.specification,
            pallet_id: e.pallet_id,
            remaining_weight: e.remaining_weight ?? 0,
            pallet_destination_id: e.pallet_destination_id ?? null,
            area_id: e.area_id ?? null,
            is_depleted: e.is_depleted ?? false,
          };
        }),
      };

      if (editForm.getFieldValue("material_handling_fee_type")) {
        dataForm.material_handling_fee_type = material_handling_fee_type;
      }

      const isPalletSameWithDestination = dataForm.details.some(
        (e) => e.pallet_id === e.pallet_destination_id,
      );

      if (isPalletSameWithDestination) {
        message.warning("Pallet asal dan tujuan tidak boleh sama.");
        return;
      }

      if (hasDestinationConflict(dataForm.details, productData)) {
        message.warning(
          "Ada pallet tujuan yang memiliki produk berbeda. Silahkan cek kembali.",
        );
        return;
      }

      const areaMap = new Map();

      for (const row of dataForm.details) {
        if (!row.area_id) continue;

        const existing = areaMap.get(row.area_id);

        if (existing) {
          const allowed =
            row.pallet_destination_id || existing.pallet_destination_id;

          if (!allowed) {
            message.warning(
              "Area tidak boleh sama dengan pallet lain kecuali menggunakan pallet tujuan.",
            );
            return;
          }
        } else {
          areaMap.set(row.area_id, row);
        }
      }

      if (dataForm.details.length < 1) {
        message.info("Belum scan RFID");
      } else {
        await API.Post("transaction/outbound/opt-out", dataForm);
        message.success("Outbound has been added");
        editForm.resetFields();
        handleBack();
      }
    } catch (err) {
      console.log(err);
      message.info(`${err?.response?.data?.error}`);
    } finally {
      setLoadingBtn(false);
      setConfirmOutbound(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setConfirmOutbound(false);
    console.log("Failed:", errorInfo);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const items = (index, remove) => [
    {
      label: "Print",
      onClick: () => {
        handlePrint(index);
      },
    },
    {
      label: "Print from Android",
      onClick: () => {
        handlePrint(index, true);
      },
    },
    {
      label: "Delete",
      onClick: () => remove(index),
    },
  ];

  const handlePrint = async (index = null, thermer = false) => {
    const allProducts = editForm.getFieldValue("details") || [];
    const scheduleAt = editForm.getFieldValue("schedule_at") || null;
    const palletName = selectedPallet?.label;

    const productsToPrint = index === null ? allProducts : [allProducts[index]];

    const validProducts = productsToPrint.filter((product) => product?.area_id);

    if (validProducts.length === 0) {
      return message.info(
        index === null
          ? "Tidak ada data yang bisa dicetak."
          : "Data di baris ini belum lengkap untuk dicetak.",
      );
    }

    if (thermer) {
      const params = new URLSearchParams();

      if (validProducts?.[0]?.warehouse) {
        params.append("warehouseName", validProducts?.[0]?.warehouse);
      }
      if (validProducts?.[0]?.area) {
        params.append("areaName", validProducts?.[0]?.area);
      }
      if (scheduleAt) {
        params.append("tanggal", dayjs(scheduleAt).format("DD-MM-YYYY"));
      }
      if (palletName) {
        params.append("palletNo", palletName);
      }

      return;
    }

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.body.innerHTML = ItemPrint(validProducts);
    setTimeout(function () {
      printWindow.document.close();
    }, 2000);

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print({ showPrintDialog: true });

      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  const handleOk = (value) => {
    editForm.setFieldValue(["details", selectionIndex, "area_id"], value.id);
    editForm.setFieldValue(["details", selectionIndex, "area"], value.name);
    editForm.setFieldValue(["details", selectionIndex, "level"], value.level);
    editForm.setFieldValue(
      ["details", selectionIndex, "warehouse"],
      value.warehouse_name,
    );

    setOpen(false);
    setSelectedArea({});
  };

  const onSelectedPallet = (value, options, index) => {
    if (value) {
      setSelectedPallet(options);

      editForm.setFieldValue(["details", index, "pallet_name"], options?.label);

      editForm.setFieldValue(["details", index, "pallet_weight"], "");
      if (!options?.type) return;

      if (options.type === "besi") {
        editForm.setFieldValue(["details", index, "pallet_weight"], 80);
      }
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          <Form
            form={editForm}
            name="Edit Form"
            style={{
              margin: "0 auto",
            }}
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row justify={"space-between"} align={"middle"}>
              <Col lg={12} md={12} sm={12} xs={24}>
                <h2>Start Outbound</h2>
              </Col>
              <Col lg={2} md={2} sm={3} xs={24}>
                <Row justify={"end"}>
                  <Button
                    type="primary"
                    icon={<PrinterOutlined />}
                    style={{
                      backgroundColor: "#4caf50",
                      color: "#fff",
                      borderColor: "#4caf50",
                      width: "100%",
                    }}
                    onClick={() => handlePrint()}
                  >
                    Print All
                  </Button>
                </Row>
              </Col>
            </Row>
            <hr />
            <br />
            <Row gutter={[8, 8]}>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item label="Kode" name="code">
                  <Input placeholder="Kode" />
                </Form.Item>
              </Col>
              <Col lg={6} md={6} sm={6} xs={24}>
                <Form.Item
                  label={
                    <span>
                      <Checkbox
                        checked={materialHandlingChecked}
                        onChange={() => {
                          setMaterialHandlingChecked(!materialHandlingChecked);
                          editForm.setFieldValue(
                            "material_handling_fee_type",
                            null,
                          );
                          editForm.setFieldValue(
                            "material_handling_fee_cost",
                            null,
                          );
                          setIsCustomMaterialHandling(false);
                        }}
                      />{" "}
                      Material Handling
                    </span>
                  }
                  name="material_handling_fee_type"
                >
                  <SelectMaterialHandling
                    onChange={onSelectedMaterialHandling}
                    disabled={!materialHandlingChecked}
                  />
                </Form.Item>
              </Col>
              <Col lg={6} md={6} sm={6} xs={24}>
                <Form.Item
                  label="Material Handling Fee per kg"
                  name="material_handling_fee_cost"
                >
                  <InputNumber
                    placeholder="Material Handling Fee"
                    prefix="Rp"
                    min={0}
                    controls={false}
                    style={{
                      width: "100%",
                    }}
                    disabled={!materialHandlingChecked}
                    readOnly={!isCustomMaterialHandling}
                  />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  label="Pemilik"
                  name="client"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Pemilik!",
                    },
                  ]}
                >
                  <Input placeholder="Pemilik" readOnly />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  label="Status"
                  name="status"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Status!",
                    },
                  ]}
                >
                  <Input placeholder="Status" readOnly />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  label="Tanggal Request"
                  name="request_at"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Tanggal Request!",
                    },
                  ]}
                >
                  <Input placeholder="Tanggal Request" readOnly />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  label="Tanggal Masuk"
                  name="schedule_at"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Tanggal Masuk!",
                    },
                  ]}
                >
                  <Input placeholder="Tanggal Masuk" readOnly />
                </Form.Item>
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                <Form.Item label="Silahkan Scan RFID">
                  <Form.List name="details">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((field, index) => (
                          <Row key={field.key} gutter={[2, 2]} align="top">
                            {/* Pallet */}
                            <Col span={3}>
                              <Form.Item
                                {...field}
                                name={[field.name, "pallet_id"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input jenis pallet!",
                                  },
                                ]}
                              >
                                <SelectPalletByClient />
                              </Form.Item>
                            </Col>
                            {/* Pallet Weight*/}

                            {/* Operator */}
                            <Col span={3}>
                              <Form.Item
                                {...field}
                                name={[field.name, "operator_id"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input jenis operator!",
                                  },
                                ]}
                              >
                                <SelectOperator />
                              </Form.Item>
                            </Col>

                            {/* Jenis Produk */}
                            <Col span={3}>
                              <Form.Item
                                {...field}
                                name={[field.name, "select_product"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please input jenis produk!",
                                  },
                                ]}
                              >
                                <SelectProductByClient
                                  onChange={(value, option) => {
                                    onSelectProduct(value, option, index);
                                    setSelectionIndex(index);
                                  }}
                                  client_id={clientId}
                                  setProductData={setProductData}
                                />
                              </Form.Item>
                            </Col>

                            {/* Berat */}
                            <Col span={2}>
                              <Form.Item
                                {...field}
                                name={[field.name, "weight"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Berat mimimum adalah 85 untuk pallet besi!",
                                    type: "number",
                                    min:
                                      editForm.getFieldValue([
                                        "details",
                                        index,
                                        "pallet_type",
                                      ]) === "besi"
                                        ? 85
                                        : 0,
                                  },
                                ]}
                              >
                                <InputNumber
                                  min={0}
                                  placeholder="Berat"
                                  suffix={"Kg"}
                                  step={"0.1"}
                                  controls={false}
                                  style={{
                                    width: "100%",
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            {/*Jumlah Pack */}
                            <Col span={2}>
                              <Form.Item {...field} name={[field.name, "qty"]}>
                                <Input placeholder="Pack" suffix={"Pack"} />
                              </Form.Item>
                            </Col>
                            <Col span={2}>
                              <Form.Item
                                {...field}
                                name={[field.name, "pallet_destination_id"]}
                              >
                                <Select
                                  style={{ width: "100%" }}
                                  allowClear
                                  showSearch
                                  optionFilterProp="label"
                                  placeholder="Pallet Tujuan"
                                  notFoundContent={
                                    loadingPallet ? (
                                      <Row justify={"center"}>
                                        <Spin size="small" className="center" />
                                      </Row>
                                    ) : (
                                      "No Data"
                                    )
                                  }
                                  options={dataPallet?.map((e) => ({
                                    label: e.name,
                                    value: e.id,
                                  }))}
                                  onChange={(value) => {
                                    onSelectedDestinationPallet(value, index);
                                    setTriggerRender(!triggerRender);

                                    if (value) {
                                      editForm.setFieldValue(
                                        ["details", index, "is_depleted"],
                                        true,
                                      );
                                    } else {
                                      editForm.setFieldValue(
                                        ["details", index, "is_depleted"],
                                        false,
                                      );
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            {/* Berat Sisa*/}
                            <Col span={2}>
                              <Form.Item
                                {...field}
                                name={[field.name, "remaining_weight"]}
                                rules={[
                                  {
                                    min:
                                      editForm.getFieldValue([
                                        "details",
                                        index,
                                        "pallet_type",
                                      ]) === "besi"
                                        ? 80
                                        : 0,
                                    type: "number",
                                    message:
                                      "Berat minimum adalah 80 untuk pallet besi!",
                                  },
                                ]}
                              >
                                <InputNumber
                                  style={{
                                    width: "100%",
                                  }}
                                  controls={false}
                                  min={0}
                                  placeholder="Sisa"
                                  suffix={"Kg"}
                                  step={"0.1"}
                                />
                              </Form.Item>
                            </Col>

                            {/* Area */}
                            <Col span={2}>
                              <Form.Item {...field} name={[field.name, "area"]}>
                                <Input
                                  placeholder="Pilih Area"
                                  readOnly
                                  onClick={() => {
                                    showModal();
                                    setSelectionIndex(index);
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            {/* Hapus */}
                            <Col
                              span={1}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Form.Item>
                                <Dropdown
                                  menu={{ items: items(index, remove) }}
                                  trigger={["click"]}
                                >
                                  <EllipsisOutlined />
                                </Dropdown>
                              </Form.Item>
                            </Col>

                            <Col span={1}>
                              <Button
                                type="primary"
                                style={{
                                  backgroundColor: "#4caf50",
                                  color: "#fff",
                                  borderColor: "#4caf50",
                                  width: "100%",
                                }}
                                onClick={() => {
                                  setSelectionIndex(index);
                                  showModalProcess();
                                }}
                              >
                                Process
                              </Button>
                            </Col>
                            <Col span={1}>
                              <Button
                                icon={
                                  <CheckCircleOutlined
                                    style={{
                                      color: editForm.getFieldValue([
                                        "details",
                                        index,
                                        "is_depleted",
                                      ])
                                        ? "red"
                                        : "gray",
                                    }}
                                  />
                                }
                                color="default"
                                variant="text"
                                style={{
                                  border: "none",
                                  marginLeft: "0.5rem",
                                }}
                                onClick={() => {
                                  let isDepleted = editForm.getFieldValue([
                                    "details",
                                    index,
                                    "is_depleted",
                                  ]);

                                  setTriggerRender(!triggerRender);

                                  editForm.setFieldValue(
                                    ["details", index, "is_depleted"],
                                    !isDepleted,
                                  );
                                }}
                              >
                                <span style={{ fontWeight: "lighter" }}>
                                  Pallet tidak menyisa
                                </span>
                              </Button>
                            </Col>
                          </Row>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "orange",
                    borderColor: "orange",
                    color: "white",
                  }}
                  type="primary"
                  onClick={() => handleBack()}
                >
                  Kembali
                </Button>
              </Col>
              <Col lg={12} md={12} sm={12} xs={24}>
                <Button
                  onClick={() => {
                    setConfirmOutbound(true);
                  }}
                  style={buttonStyle}
                  type="primary"
                  loading={loadingBtn}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
          <Modal
            title="Silahkan Pilih Rak"
            okText="Ok"
            cancelText="Tutup"
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            okType={"primary"}
            width="80%"
            height="80%"
            footer={null}
          >
            <SelectLayoutNew
              value={selectedArea?.id}
              onChange={(value) => {
                handleOk(value);

                setSelectedArea(value);
              }}
            />
          </Modal>

          <Modal
            title="Konfirmasi Outbound"
            okText="Ok"
            cancelText="Tutup"
            open={confirmOutbound}
            onOk={() => editForm.submit()}
            confirmLoading={loadingBtn}
            onCancel={() => setConfirmOutbound(false)}
            okType={"primary"}
          >
            <p>
              Anda akan menyimpan outbound. Apakah data yang diisi sudah sesuai?
            </p>
            <p style={{ color: "red" }}>
              Data yang tersimpan tidak dapat diubah.
            </p>
          </Modal>

          <Process
            openProcess={openProcess}
            setOpenProcess={handleCancelProcess}
            handleOkProcess={handleOkProcess}
            onSelectedPallet={onSelectedPallet}
            selectionIndex={selectionIndex}
          />
        </>
      )}
    </>
  );
};

const buttonStyle = {
  width: "100%",
};


StartOutbound.propTypes = {

};

export default StartOutbound;
